// Serves as the map annimation and time controller

var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.MapDateTime = new Class({
    Extends: OCS.Functions.define_OCSDateTime(),
    class_name: "MapDateTime",
    live_time_obj: null,
    animation_interval: null,
    animation_method: null,
    animation_event_timeout: null,
    previous_epoch_time: 0,
    linked_datetime: null,
    options: {
        debug: false,
        animation_rate_base: 500, // The slowest rate in miliseconds a frame change can occur in an animation.
        animation_rate_ceiling: 15, // The fastest rate in miliseconds a frame change can occur in an animation.
        animation_direction: 1, // positive is forward, negative is backward        
        animation_speed: 200, // how many milliseconds have passed to trigger a frame change        
        animation_type: 'loop', // "loop", "rock", or "none"
        end_pause: 500, // how many milliseconds we want to pause at the end of the animation
        events: {
        },
        time_increment: 10000, // Update every 10 seconds
    },
    bound_methods: {},
    //
    // Initialization methods
    //
    initialize: function (op) {
        this.setOptions(op);
        if(OCS.Settings.anchor) {
            this.set_anchor(OCS.Settings.anchor);
        }
        this.bound_methods.time_update = this.on_time_update.bind(this);
        var live_date = this.get_live_time_obj();
        live_date.addEvent('time_update', this.bound_methods.time_update);
        // Get the actual server to local offset and store it
        this.set_server_to_local_offset(live_date.get_server_to_local_offset());
        this.initialize_events();
        this.load_user_preferences();
    },
    initialize_events: function () {
        this.parent();
        this.addEvent('go_to_frame', this.on_go_to_frame.bind(this));
    },
    load_user_preferences: function () {
        //this.parent();
        //this.options.animation_speed = OCS.User.get_user_preference('anim_speed');
    },
    // 
    // Event Fires
    //

    animation_started: function () {
        this.fireEvent('animation_started');
    },
    animation_stopped: function () {
        this.fireEvent('animation_stopped');
    },

    // 
    // Event Listeners
    //  
    on_pause: function () {
        this.stop_animation();
        this.fireEvent('send_ga_event', {'category': 'Animation', 'action': "Pause"});
    },
    on_play: function () {
        this.start_animation(this.animate.bind(this));
        this.fireEvent('send_ga_event', {'category': 'Animation', 'action': "Play"});
    },
    on_stop: function () {
        this.stop_animation();
        this.fireEvent('send_ga_event', {'category': 'Animation', 'action': "Stop"});
    },
    on_time_update: function () {
        this.time_update();
    },
    on_go_to_first_frame: function () {
        this.on_go_to_frame({current: this.get_start_epoch_time()});
        this.fireEvent('send_ga_event', {'category': 'Animation', 'action': "First Frame"});
    },
    on_go_to_last_frame: function () {
        this.on_go_to_frame({current: this.get_end_epoch_time()});
        this.fireEvent('send_ga_event', {'category': 'Animation', 'action': "Last Frame"});
    },
    on_go_to_next_frame: function () {
        this.set_animation_direction(1);
        this.update_animation_frame();
    },
    on_go_to_previous_frame: function () {
        this.set_animation_direction(-1);
        this.update_animation_frame();
    },
    on_go_to_frame: function (time) {
        this.stop_animation();
        this.update_animation_frame(this.get_frame_from_timestamp(time.current));
    },
    //
    // Actions
    //
    animate: function () {
        var current_local_time = this.get_local_epoch_time();
        if (this.end_pause_time) {
            // If the end pause is active, lets wait a few iterations before continuing.
            if ((current_local_time - this.end_pause_time) >= this.options.end_pause) {
                //this.set_end_pause(false); // 
                this.update_animation_frame();
            }
        } else {
            this.update_animation_frame();
        }

        if (this.options.debug) {
            var end_animation_local_time = this.get_local_epoch_time();
            var speed = this.get_animation_speed();

            console.log('map_datetime: annimation took ' + (end_animation_local_time - current_local_time) + ' ms with an animation speed of ' + speed + '.');
        }
    },
    update_animation_frame: function (frame) {
        // Frame should be in epoch time
        var util = OCS.Viewer.Functions.get_utilities();
        if (!util.isNumber(frame) || !frame) {
            frame = this.get_next_frame();
        }

        frame = this.get_frame_from_timestamp(frame);
        this.set_current_epoch_time(frame);

        if (this.options.debug) {
            console.debug("map_manager: update animation frame called for timestamp: " + this.get_display_time_string(this.get_current_epoch_time()));
        }
        this.time_update();

    },

    // map animation controls
    start_animation: function (method) {
        if (!method) {
            method = this.animation_method;
        }
        this.animation_method = method;
        this.stop_animation();
        this.animation_interval = setInterval(method, this.get_animation_speed());
        this.animation_started();
    },
    stop_animation: function () {
        if (this.animation_interval) {
            clearInterval(this.animation_interval);
            this.animation_interval = null;
            this.animation_stopped();
        }
    },

    //
    // Queries
    //
    is_anchored: function () {
        return this.options.anchor;
    },
    is_animating: function () {
        if (this.animation_interval) {
            return true;
        } else {
            return false;
        }
    },
    is_in_current_step: function (item_timestamp) {
        return this.is_in_step(this.get_current_epoch_time(), item_timestamp);
    },
    is_in_step: function (time_step, item_timestamp) {
        time_step = this.get_frame_from_timestamp(time_step);
        if (item_timestamp <= time_step && item_timestamp > (time_step - this.options.animation_step)) {
            return true;
        } else {
            return false;
        }

    },
    is_close_to_timestep: function (time_step, item_timestamp) {
        time_step = this.get_frame_from_timestamp(time_step);
        if (item_timestamp <= (time_step + this.options.animation_step / 2) && (item_timestamp >= (time_step - this.options.animation_step / 2))) {
            return true;
        } else {
            return false;
        }
    },
    //
    // Getter and Setters
    //
    get_animation_settings: function () {
        return {
            animation_rate_base: this.options.animation_rate_base,
            animation_rate_ceiling: this.options.animation_rate_ceiling,
            animation_direction: this.options.animation_direction,
            animation_speed: this.options.animation_speed
        };
    },
    get_animation_speed: function () {
        return this.options.animation_speed;
    },
    get_current_epoch_time: function () {
        if (this.linked_datetime) {
            return this.linked_datetime.get_current_epoch_time();
        }
        return this.parent();
    },
    get_end_epoch_time: function () {
        if (this.linked_datetime) {
            return this.linked_datetime.get_end_epoch_time();
        }
        return this.parent();
    },
    get_live_time_obj: function () {
        if (!this.live_time_obj) {
            this.live_time_obj = OCS.Functions.get_OCSDateTime();
        }
        return this.live_time_obj;
    },
    get_next_frame: function () {
        var new_current_frame, start_ts, end_ts, step, dir, old_current_frame;
        start_ts = this.get_start_epoch_time();
        end_ts = this.get_end_epoch_time();
        step = this.get_animation_step();
        dir = this.options.animation_direction;
        old_current_frame = this.get_current_epoch_time();
        new_current_frame = old_current_frame + (dir * step);
        new_current_frame = (new_current_frame < start_ts) ? start_ts : new_current_frame;
        new_current_frame = (new_current_frame > end_ts) ? end_ts : new_current_frame;
        switch (this.options.animation_type) {
            case 'loop':
                new_current_frame = this.get_next_frame_loop(new_current_frame);
                break;

            case 'rock':
                new_current_frame = this.get_next_frame_rock(new_current_frame);
                break;
        }
        return new_current_frame;
    },
    get_next_frame_loop: function (new_current_frame) {
        var start_ts = this.get_start_epoch_time();
        start_ts = this.get_frame_from_timestamp(start_ts);

        var end_ts = this.get_end_epoch_time();
        end_ts = this.get_frame_from_timestamp(end_ts);


        var dir = this.options.animation_direction;
        var old_current_frame = this.get_current_epoch_time();
        if (old_current_frame >= end_ts && (dir === 1)) {
            //last frame
            if (this.end_pause_time) {
                this.set_end_pause(false);
                new_current_frame = start_ts;
            } else {
                this.set_end_pause(true);
            }
        } else if (old_current_frame <= start_ts && (dir === -1)) {
            //first frame
            if (this.end_pause_time) {
                this.set_end_pause(false);
                new_current_frame = end_ts;
            } else {
                this.set_end_pause(true);
            }
        }
        return new_current_frame;
    },
    get_next_frame_rock: function (new_current_frame) {
        var start_ts = this.get_start_epoch_time();
        start_ts = this.get_frame_from_timestamp(start_ts);

        var end_ts = this.get_end_epoch_time();
        end_ts = this.get_frame_from_timestamp(end_ts);



        var old_current_frame = this.get_current_epoch_time();
        if (old_current_frame >= end_ts) {
            //last frame, start moving backward
            if (this.end_pause_time) {
                this.set_end_pause(false);
                this.set_current_epoch_time(end_ts);
                this.set_animation_direction(-1);
            } else {
                this.set_end_pause(true);
            }
        } else if (old_current_frame <= start_ts) {
            //first frame, start moving forward
            if (this.end_pause_time) {
                this.set_end_pause(false);
                this.set_current_epoch_time(start_ts);
                this.set_animation_direction(1);
            } else {
                this.set_end_pause(true);
            }
        } else {
            this.set_end_pause(false);
        }
        return new_current_frame;
    },
    get_start_epoch_time: function () {
        if (this.linked_datetime) {
            return this.linked_datetime.get_start_epoch_time();
        }
        return this.parent();
    },

    set_animation_direction: function (val) {
        if (val === -1 || val === 1) {
            this.options.animation_direction = val;
        }
    },
    set_animation_speed: function (val) {
        this.options.animation_speed = val;
    },
    set_animation_type: function (val) {
        if (val === 'loop' || val === 'rock') {
            this.options.animation_type = val;
        }
    },
    set_current_epoch_time: function (value) {
        var old = this.time_settings.current;
        if (this.linked_datetime) {
            return this.linked_datetime.set_current_epoch_time(value);
        }
        this.parent(value);
        if (this.time_settings.current !== old) {
            this.fireEvent('time_update', this);
        }
    },
    set_end_pause: function (cond) {
        if (cond) {
            this.end_pause_time = this.get_local_epoch_time();
        } else {
            this.end_pause_time = 0;
        }
    },
    set_linked_datetime: function (datetime) {
        if (this.linked_datetime) {
            this.linked_datetime.removeEvent('time_update', this.bound_methods.time_update);
        }
        this.linked_datetime = datetime;
        if (this.linked_datetime) {
            this.linked_datetime.addEvent('time_update', this.bound_methods.time_update);
        }
    },
    //
    // Destruction methods
    //
    destroy: function () {
        this.set_linked_datetime(null);
        this.stop_animation();
        var live_date = this.get_live_time_obj();
        live_date.removeEvent('time_update', this.bound_methods.time_update);
        this.removeEvents();
    }
});
